import { render } from "./EventHall.vue?vue&type=template&id=6c9055ff&scoped=true"
import script from "./EventHall.vue?vue&type=script&lang=js"
export * from "./EventHall.vue?vue&type=script&lang=js"

import "./EventHall.vue?vue&type=style&index=0&id=6c9055ff&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9055ff"]])

export default __exports__